import React from 'react';
import { CircularProgress, Paper } from '@mui/material';

export default function InsightsLoader() {
  return (
    <div
      style={{
        minHeight: '100%',
        padding: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress />
    </div>
  );
}
